const initialState = {
    search: '',
    page: 0,
    rowsPerPage: 10
};

const contactReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_SEARCH_CONTACT':
            return { ...state, search: action.payload, page: 0 };
        case 'SET_PAGE_CONTACT':
            return { ...state, page: action.payload };
        case 'SET_ROWS_PER_PAGE_CONTACT':
            return { ...state, rowsPerPage: action.payload };
        default:
            return state;
    }
};

export default contactReducer;
